import React, { useEffect, useRef, useState } from "react";
import css from "./.module.scss";

export function ShowMore({
  children,
  lines = 2,
  buttonText = "المزيد",

  className,
  ...props
}) {
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(
    children?.split("\n").length > lines,
  );
  const el = useRef();

  useEffect(() => {
    setShowButton(children?.split("\n").length > lines);
  }, [children, lines]);
  return (
    <div
      onClick={() => {
        if (expanded) return;
        setExpanded(true);
      }}
      {...props}
      style={{
        "--lines-count": lines,
      }}
      className={(expanded ? css.expanded : css.root) + " " + className}
    >
      <p ref={el}> {children}</p>
      {showButton ? (
        <div dir="auto" className={css.more}>
          {!expanded ? <button type="button">{buttonText}</button> : null}
        </div>
      ) : null}
    </div>
  );
}
